module.exports = __webpack_public_path__ + "static/builder-factory@2x-6254470c67c3cd7c547187f37f5a9a64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/ios-app-builder/builder-factory@2x.jpg
// module id = 2648
// module chunks = 168707334958949